import { useSearchParams } from "react-router-dom";
import ShopJobList from "./ShopJobList";

const ShopJobsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let search = searchParams.get("search");
  let status = searchParams.get("status");

  return <ShopJobList search={search} status={status ?? "OPEN"} />;
};

export default ShopJobsPage;
